import { useMutation } from '@apollo/client/react';
import { Spinner } from '@optools/components/loading/spinner';
import { Switch } from '@optools/components/ui/switch';
import { TOGGLE_SKYVIEW_CONFIG } from '@optools/services/operator-gateway/btc/mutations';
import { SKYVIEW_CONFIGS } from '@optools/services/operator-gateway/btc/queries';

export interface SkyviewConfigSwitchProps {
  enabled: boolean;
  language: string;
  teamId: number;
}

export function SkyviewConfigSwitch({ enabled, language, teamId }: SkyviewConfigSwitchProps) {
  const [toggleSkyviewConfig, { loading }] = useMutation(TOGGLE_SKYVIEW_CONFIG, {
    awaitRefetchQueries: true,
    refetchQueries: [{ query: SKYVIEW_CONFIGS }],
  });

  return (
    <div className="relative flex items-center justify-center">
      {loading && <Spinner className="absolute -left-4 size-3" variant="loader" />}
      <Switch
        aria-label={`${language} Skyview config status`}
        checked={enabled}
        disabled={loading}
        onCheckedChange={(checked) => {
          toggleSkyviewConfig({ variables: { enabled: checked, language, teamId } });
        }}
      />
    </div>
  );
}
